function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#379b75",
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    version: 1.1,
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100"
  }, props), React.createElement("g", {
    transform: "translate(0,-952.36218)"
  }, React.createElement("path", {
    style: {
      "textIndent": 0,
      "textTransform": "none",
      "direction": "ltr",
      "blockProgression": "tb",
      "baselineShift": "baseline",
      "color": "#000000",
      "enableBackground": "accumulate"
    },
    d: "m 30.031199,958.36218 c -1.104501,0 -2,0.8954 -2,2 l 0,11 c 0,1.1045 0.895499,2 2,2 1.104599,0 2,-0.8955 2,-2 l 0,-11 c 0,-1.1046 -0.895401,-2 -2,-2 z m 39.999999,0 c -1.1045,0 -2,0.8954 -2,2 l 0,11 c 0,1.1045 0.8955,2 2,2 1.1046,0 2,-0.8955 2,-2 l 0,-11 c 0,-1.1046 -0.8954,-2 -2,-2 z m -54,8 c -4.4455,0 -8.0311995,3.5854 -8.0311995,8.0312 l 0,17.9688 84.0000025,0 0,-17.9688 c 0,-4.4458 -3.5858,-8.0312 -8.031199,-8.0312 l -5.968801,0 -3.968802,0 0,7.0937 c 2.385703,1.39 4.000003,3.9651 4.000003,6.9063 0,4.3946 -3.605003,8 -8.000003,8 -4.3943,0 -8,-3.6054 -8,-8 0,-2.9412 1.6146,-5.5163 4,-6.9063 l 0,-7.0937 -32.0312,0 0,7.0625 c 2.4061,1.3846 4.0312,3.981 4.0312,6.9375 0,4.3946 -3.605,8 -8,8 -4.3943,0 -8,-3.6054 -8,-8 0,-2.9317 1.5958,-5.5131 3.9688,-6.9063 l 0,-7.0937 z m 14,10 c -2.2324,0 -4,1.7671 -4,4 0,2.2328 1.7676,4 4,4 2.2328,0 4,-1.7672 4,-4 0,-2.2329 -1.7672,-4 -4,-4 z m 40,0 c -2.232399,0 -4,1.7671 -4,4 0,2.2328 1.767601,4 4,4 2.2328,0 4,-1.7672 4,-4 0,-2.2329 -1.7672,-4 -4,-4 z m -62.0311995,20 0,41.96872 c 0,4.4458 3.5855995,8.0313 8.0311995,8.0313 l 67.937603,0 c 4.4454,0 8.0312,-3.5855 8.0312,-8.0313 l 0,-41.96872 z",
    fill: "#379b75",
    fillOpacity: 1,
    stroke: "none",
    marker: "none",
    visibility: "visible",
    display: "inline",
    overflow: "visible"
  })));
};
export default __webpack_public_path__ + "static/media/opp-calendar.e1aab657.svg";
export { SvgComponent as ReactComponent };